@let contractorId =
  formGroup.controls[Field.ContractorCounterparty].value?.id ?? null;
@let subdivisionId =
  formGroup.controls[Field.ContractorSubdivision].value?.id ?? null;

<form
  class="flex min-w-[320px] flex-col gap-4 p-4"
  [formGroup]="formGroup"
  (ngSubmit)="submit()"
>
  @if ($titleKey(); as titleKey) {
    <h3 class="x-font-body-1-bold">
      {{ titleKey | translate }}
    </h3>
  }

  <label class="flex flex-col gap-1">
    <span class="x-input-label">
      {{ 'request_form.summary.installer_assignment.contractor' | translate }}
    </span>
    <x-form-picker
      [formControlName]="Field.ContractorCounterparty"
      [withCleaner]="true"
      xAttachExecutors
    />
  </label>

  @if (contractorId) {
    <label class="flex flex-col gap-1">
      <span class="x-input-label">
        {{
          'request_form.summary.installer_assignment.subdivision' | translate
        }}
      </span>
      <x-form-picker
        [formControlName]="Field.ContractorSubdivision"
        [withCleaner]="true"
        [contractorId]="contractorId"
        xAttachSubdivisions
      />
    </label>
  }

  @if (contractorId && subdivisionId) {
    <label class="flex flex-col gap-1">
      <span class="x-input-label">
        {{ 'request_form.summary.installer_assignment.zone' | translate }}
      </span>
      <x-form-picker
        [formControlName]="Field.InstallZone"
        [withCleaner]="true"
        [ownerId]="$ownerId()"
        [contractorId]="contractorId"
        [contractorSubdivisionId]="subdivisionId"
        xAttachZones
      />
    </label>

    <label class="flex flex-col gap-1">
      <span class="x-input-label">
        {{ 'request_form.summary.installer_assignment.installer' | translate }}
      </span>
      <x-form-picker
        [formControlName]="Field.Installer"
        [withCleaner]="true"
        [stringifyFn]="installerStringify"
        [contractorId]="contractorId"
        [contractorSubdivisionId]="subdivisionId"
        xAttachAssignmentInstallers
      />
    </label>
  }

  <div class="mt-2 flex flex-wrap justify-end" tuiGroup>
    <button
      tuiButton
      type="button"
      appearance="secondary-destructive"
      size="m"
      [disabled]="loading.value"
      (click)="clearInstaller()"
    >
      {{ 'request_form.summary.installer_assignment.clear' | translate }}
    </button>
    @if ($showCancel()) {
      <button
        tuiButton
        type="button"
        appearance="secondary"
        size="m"
        [disabled]="loading.value"
        (click)="cancel()"
      >
        {{ 'common.cancel' | translate }}
      </button>
    }
    <button
      tuiButton
      type="submit"
      appearance="primary"
      size="m"
      [disabled]="formGroup.invalid || loading.value"
    >
      {{ 'common.save' | translate }}
    </button>
  </div>
</form>
